<template>
  <div class="jx_dove">
    <div class="jx_top_logo">
      <div class="jx_t_left jx_img_logo"></div>
      <div class="jx_t_right">
        <img alt="" src="~@/assets/imgs/dove/001.png">
      </div>
    </div>
    <div class="jx_top_title_box">
      <div class="jx_t_005">
        <img alt="" src="~@/assets/imgs/dove/005.png">
      </div>
      <div class="jx_t_004">
        <img alt="" src="~@/assets/imgs/dove/004.png">
      </div>
    </div>
    <div class="jx_center">
      <div class="jx_top_name">
        <div class="jx_t_n_logo jx_img_logo"></div>
        <!-- <div class="jx_t_n">
          <img alt="" src="~@/assets/imgs/dove/005.png"/>
          <p>微信号：{{data.wechat_number}}</p>
        </div>
        <div
          :data-clipboard-text="data.wechat_number"
          @click="copyText"
          class="jx_t_n_button copy_dom"
          data-clipboard-action="copy"
        >
          一键复制
        </div> -->
      </div>
      <div class="jx_text_box">
        <p>{{data.text}}</p>
      </div>
      <div class="jx_qr_box">
        <div class="jx_qr">
          <img :src="code" alt="">
        </div>
      </div>
      <div class="jx_footer_text">
        <p>请截图保存二维码在微信内扫一扫并且添加好友，芙姐马上邀请你进群</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {goGet} from '@/utils/public'
  import jrQrcode from 'jr-qrcode'
  export default {
    name: 'jxDove',
    data() {
      return {
        data: {
        },
        ajaxJson: {
          project: '德芙',
          type: '红包'
        },
        code: ''
      }
    },
    created() {},
    methods: {
      copyText() {
        let _this = this
        let Clipboard = new this.Clipboard('.copy_dom')
        Clipboard.on('success', function () {
          _this.$toast('复制成功')
        })
        Clipboard.on('error', function () {
          _this.$toast('复制失败')
        })
      },
      resCode() {
        this.code = jrQrcode.getQrBase64(this.data.qr_code)
      }
    },
    components: {},
    computed: {},
    async mounted() {
      let thisData = await goGet('https://smallappapi.taotonggroup.com/mall/v1/activity', this.ajaxJson)
      if(thisData.code === 200) {
        this.data = thisData.data.data[0]
        this.resCode()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .jx_dove {
    font-family: Microsoft YaHei;
    min-height: 100vh;
    background: url("~@/assets/imgs/dove/bg.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    img {
      display: block;
    }

    .jx_img_logo {
      background: url("~@/assets/imgs/dove/002.png") no-repeat;
      background-size: 100% 100%;
    }

    .jx_top_logo {
      height: 62px;
      padding-top: 22px;
      padding-left: 19px;
      position: relative;

      .jx_t_left {
        height: 42px;
        width: 110px;
      }

      .jx_t_right {
        height: 214px;
        position: absolute;
        top: -30px;
        right: -86px;

        img {
          height: 214px;
        }
      }
    }

    .jx_top_title_box {
      margin-top: 24px;

      .jx_t_005, .jx_t_004 {
        display: flex;
        justify-content: center;
      }

      .jx_t_005 {
        img {
          height: 28px;
        }
      }

      .jx_t_004 {
        margin-top: 4px;

        img {
          height: 60px;
        }
      }
    }

    .jx_center {
      margin: 8px auto 0;
      width: 336px;
      /*height: 422px;*/
      background: url("~@/assets/imgs/dove/006.png") no-repeat;
      background-size: 100% 100%;
      padding-top: 28px;

      .jx_top_name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 23px;

        .jx_t_n_logo {
          width: 77px;
          height: 29px;
        }

        .jx_t_n {
          flex: 1;
          margin-left: 6px;

          img {
            height: 15px;
            width: 62px;
          }

          p {
            font-size: 12px;
            font-weight: 400;
            color: rgba(245, 94, 115, 1);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .jx_t_n_button {
          margin-top: 2px;
          width: 70px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background: rgba(245, 94, 115, 1);
          border-radius: 9px;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
        }
      }

      .jx_text_box {
        margin-top: 28px;
        padding: 0 47px;
        font-size: 15px;
        color: #333;
        height: 28px;

        p {
          width: 100%;
          word-wrap: break-word;
          word-break: normal;
        }
      }

      .jx_qr_box {
        margin-top: 94px;
        display: flex;
        justify-content: center;
        align-items: center;

        .jx_qr {
          width: 146px;
          height: 146px;
          background: #fff;
          padding: 8px;
          border-radius: 3px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 3px;
          }
        }
      }

      .jx_footer_text {
        padding: 18px 30px 52px;

        p {
          font-size: 12px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 16px;
          text-align: center;
        }
      }
    }
  }
</style>
